import authCodes from "../constants/authCodes";
import i18n from '../i18n';

export const getLoginValidationMessage = (validationCode) => {
  switch (validationCode) {
    case (authCodes.INVALID_EMAIL):
    case (authCodes.USER_NOT_FOUND):
      return { email: i18n.t('auth.enterCorrectUsername') };
    case (authCodes.WRONG_PASSWORD):
      return { password: i18n.t('auth.enterCorrectPassword') };
    default:
      return { email: 'Error' };
  }
};

export const getForgotPasswordValidationMessage = (validationCode) => {
  switch (validationCode) {
    case (authCodes.INVALID_EMAIL):
    case (authCodes.USER_NOT_FOUND):
      return i18n.t('auth.emailNotExist');
    default:
      return 'Error';
  }
};

export const getNewPasswordValidationMessage = (validationCode) => {
  switch (validationCode) {
    case (authCodes.WRONG_PASSWORD):
      return { oldPasswordError: i18n.t('auth.incorrectPassword') };
    default:
      return { oldPasswordError: 'Error' };
  }
};

export const passwordValidationError = (password, policies = null) => {
  const constraints = policies?.constraints || {};
  const {
    minLength = 6,
    requireLowercase,
    requireUppercase,
    requireNumeric,
    requireNonAlphanumeric,
  } = constraints;

  const getRegex = () => {
    if (!policies || !policies.constraints) {
      return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,}$/;
    }

    let regexString = '^';
    let lookaheads = '';

    if (requireNumeric) {
      lookaheads += '(?=.*\\d)';
    }
    if (requireLowercase) {
      lookaheads += '(?=.*[a-z])';
    }
    if (requireUppercase) {
      lookaheads += '(?=.*[A-Z])';
    }
    if (requireNonAlphanumeric) {
      lookaheads += '(?=.*[^a-zA-Z0-9])';
    }

    regexString += lookaheads;
    regexString += '(?!.*\\s)';
    
    const length = Number.isInteger(minLength) && minLength > 0 ? minLength : 8;
    regexString += `.{${length},}`;
    regexString += '$';

    return new RegExp(regexString);
  };
  const regex = getRegex();

  if (password.match(regex)) {
    return '';
  }

  const requirementParts = [];
  if (requireLowercase) {
    requirementParts.push(i18n.t('auth.passwordRequirements.lowercase'));
  }
  if (requireUppercase) {
    requirementParts.push(i18n.t('auth.passwordRequirements.uppercase'));
  }
  if (requireNumeric) {
    requirementParts.push(i18n.t('auth.passwordRequirements.digit'));
  }
  if (requireNonAlphanumeric) {
    requirementParts.push(i18n.t('auth.passwordRequirements.special'));
  }

  if (requirementParts.length === 0) {
    return i18n.t('auth.invalidPasswordSimple', { minLength });
  }

  const lang = i18n.language || 'en';

  const listFormatter = new Intl.ListFormat(lang, {
    style: 'long',
    type: 'conjunction',
  });
  const requirementsList = listFormatter.format(requirementParts);

  return i18n.t('auth.invalidPasswordComplex', {
    minLength,
    requirements: requirementsList,
  });
};

export const duplicatePasswordsError = (password1, password2) => {
  return password1 === password2 ? i18n.t('auth.identicalPassword') : '';
};

export const timeslotBloodTypeValidationMessage = (data) => {
  const { donorType } = data;
  return (!donorType || donorType.length <= 0) ? i18n.t('configuration.settings.selectBloodType') : '';
};

export const timeslotStartTimeValidationMessage = (data) => {
  const { startDate, endDate } = data;
  return endDate < startDate ? i18n.t('configuration.settings.shouldBeBeforeEnd') : '';
};

export const timeslotEndTimeValidationMessage = (data, duration) => {
  const { startDate, endDate } = data;
  return endDate < startDate
    ? i18n.t('configuration.settings.shouldBeAfterStart')
    : Math.abs(endDate - startDate) < duration ? i18n.t('configuration.settings.shouldBeGraterThanDuration') : '';
};

export const timeslotTimeDifferenceValidationMessage = (data) => {
  const { startDate, endDate } = data;
  return endDate < startDate ? i18n.t('configuration.settings.shouldBeLessThanTheEndTime') : '';
};

export const timeslotTimeDurationValidationMessage = (data, duration) => {
  const { startDate, endDate } = data;
  return endDate >= startDate && Math.abs(endDate - startDate) < duration
    ? i18n.t('configuration.settings.shouldNotBeLessThanDuration')
    : '';
};
